export default function GetLastElementsInList<T>(elements: T[], numberOfElements?: number): T[] {
    if (numberOfElements == undefined)
        return elements;

    const start = elements.length - numberOfElements
    const end = elements.length
    return elements.slice(start, end)
}
